const BOTTOMSHEET_PREFIX = "bottomsheet";

export const SLOT_TEST_IDS = {
    BUTTON: "slot_button",
    SLOTS_LIST: "slots_list",
    SLOT_BOTTOMSHEET_TITLE: `${BOTTOMSHEET_PREFIX}_title`,
    SLOT_BOTTOMSHEET_SUBTITLE: `${BOTTOMSHEET_PREFIX}_subtitle`,
    SELECT_DELIVERY_SLOT_BUTTON: "select-delivery-slot-button",
};
